// /* eslint-disable jsx-a11y/anchor-is-valid */
// import { FC, useEffect, useRef } from 'react'
// import { KTIcon } from '../../../../helpers'
// import { getCSSVariableValue } from '../../../../assets/ts/_utils'
// import { useThemeMode } from '../../../layout/theme-mode/ThemeModeProvider'
// import { useAuth } from '../../../../../app/modules/auth'

// type Props = {
//   className: string
//   chartSize?: number
//   chartLine?: number
//   chartRotate?: number
//   title?: string
//   label1?: string
//   label2?: string
//   label3?: string
//   amount1?: string
//   amount2?: string
//   amount3?: string
//   mainAmount?: string
//   percentChange?: string
//   positive?: boolean
//   data: any
// }

// const CardsWidget17: FC<Props> = ({
//   className,
//   chartSize = 70,
//   chartLine = 11,
//   chartRotate = 145,
//   title = "Removed from Environment",
//   label1 = "Marine",
//   label2 = "Land Based",
//   label3 = "Overdue",
//   amount1 = "$7,660",
//   amount2 = "$2,820",
//   amount3 = "$45,257",
//   mainAmount = "69,700",
//   percentChange = "2.2%",
//   positive = true,
//   data
// }) => {
//   const chartRef = useRef<HTMLDivElement | null>(null)
//   const { mode } = useThemeMode()
//   useEffect(() => {
//     refreshChart()
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [mode])


//   const { currentUser } = useAuth() as { currentUser: any };


//   const refreshChart = () => {
//     if (!chartRef.current) {
//       return
//     }

//     setTimeout(() => {
//       initChart(chartSize, chartLine, chartRotate)
//     }, 10)
//   }

//   return (
//     <div className={`card card-flush ${className}`}>
//       <div className='card-header pt-5'>
//         <div className='card-title d-flex flex-column'>
//           <div className='d-flex align-items-center'>
//             {/* {currentUser?.userType === "SMART_CENTRE" && (
//               <span className='fs-4 fw-semibold text-gray-400 me-1 align-self-start'>$</span>
//             )} */}
//             <span className='fs-2hx fw-bold text-dark me-2 lh-1 ls-n2'>69,700</span>

//             <span className='badge badge-light-success fs-base'>
//               <KTIcon iconName='arrow-up' className='fs-5 text-success ms-n1' /> kg
//             </span>
//           </div>
//           <span className='text-gray-400 pt-1 fw-semibold fs-6'>{title}</span>
//         </div>
//       </div>

//       <div className='card-body pt-2 pb-4 d-flex flex-wrap align-items-center'>
//         <div className='d-flex flex-center me-5 pt-3'>
//           {/* <div
//             id='kt_card_widget_17_chart'
//             ref={chartRef}
//             style={{ minWidth: chartSize + 'px', minHeight: chartSize + 'px' }}
//             data-kt-size={chartSize}
//             data-kt-line={chartLine}
//           ></div> */}
//         </div>

//         <div className='d-flex flex-column content-justify-center flex-row-fluid'>
//           <div className='d-flex fw-semibold align-items-center'>
//             <div className='bullet w-8px h-3px rounded-2 bg-success me-3'></div>
//             <div className='text-gray-500 flex-grow-1 me-4'>{label1}</div>
//             <div className='fw-bolder text-gray-700 text-xxl-end'>{data?.yearlyDetails?.totalPaidAmount}</div>
//           </div>
//           <div className='d-flex fw-semibold align-items-center my-3'>
//             <div className='bullet w-8px h-3px rounded-2 bg-primary me-3'></div>
//             <div className='text-gray-500 flex-grow-1 me-4'>{label2}</div>
//             <div className='fw-bolder text-gray-700 text-xxl-end'>{data?.yearlyDetails?.totalOutstandingTaxes}</div>
//           </div>
//           <div className='d-flex fw-semibold align-items-center'>
//             <div
//               className='bullet w-8px h-3px rounded-2 me-3'
//               style={{ backgroundColor: '#E4E6EF' }}
//             ></div>
//             <div className='text-gray-500 flex-grow-1 me-4'>{label3}</div>
//             <div className=' fw-bolder text-gray-700 text-xxl-end'>{data?.yearlyDetails?.totalOverdueTaxes}</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// const initChart = function (
//   chartSize: number = 70,
//   chartLine: number = 11,
//   chartRotate: number = 145
// ) {
//   const el = document.getElementById('kt_card_widget_17_chart')
//   if (!el) {
//     return
//   }
//   el.innerHTML = ''

//   var options = {
//     size: chartSize,
//     lineWidth: chartLine,
//     rotate: chartRotate,
//     //percent:  el.getAttribute('data-kt-percent') ,
//   }

//   const canvas = document.createElement('canvas')
//   const span = document.createElement('span')

//   // @ts-ignore
//   if (typeof G_vmlCanvasManager !== 'undefined') {
//     // @ts-ignore
//     G_vmlCanvasManager.initElement(canvas)
//   }

//   const ctx = canvas.getContext('2d')
//   canvas.width = canvas.height = options.size

//   el.appendChild(span)
//   el.appendChild(canvas)

//   // @ts-ignore
//   ctx.translate(options.size / 2, options.size / 2) // change center
//   // @ts-ignore
//   ctx.rotate((-1 / 2 + options.rotate / 180) * Math.PI) // rotate -90 deg

//   //imd = ctx.getImageData(0, 0, 240, 240);
//   const radius = (options.size - options.lineWidth) / 2

//   const drawCircle = function (color: string, lineWidth: number, percent: number) {
//     percent = Math.min(Math.max(0, percent || 1), 1)
//     if (!ctx) {
//       return
//     }

//     ctx.beginPath()
//     ctx.arc(0, 0, radius, 0, Math.PI * 2 * percent, false)
//     ctx.strokeStyle = color
//     ctx.lineCap = 'round' // butt, round or square
//     ctx.lineWidth = lineWidth
//     ctx.stroke()
//   }

//   // Init 2
//   drawCircle('#E4E6EF', options.lineWidth, 100 / 100)
//   drawCircle(getCSSVariableValue('--bs-primary'), options.lineWidth, 100 / 150)
//   drawCircle(getCSSVariableValue('--bs-success'), options.lineWidth, 100 / 250)
// }

// export { CardsWidget17 }
import { FC } from 'react'

type Props = {
  className: string
  collectionValue?: string | number
  recyclingValue?: string | number
  collection?: string | number
  recycling?: string | number
  title?: string
  data?: any
}

const CardsWidget17: FC<Props> = ({
  className,
  collectionValue = "0",
  recyclingValue = "0",
  collection = "0",
  recycling = "0",
  title,
  data
}) => {
  return (
    <div className={`${className}`} style={{ position: 'relative', height: '520px', width: '100%' }}>
      {/* First Card - Completed */}
      <div style={{
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        padding: '16px',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'start'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            backgroundColor: '#fae8fb',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '16px',
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#1a1a1a'
          }}>
            <img
              src="/completed .png"
              alt="Icon"
              style={{
                width: '80%',
                height: '80%',
                objectFit: 'cover'
              }}
            />
          </div>
          <div style={{ textAlign: 'left' }}>
            <div style={{ fontSize: '16px', fontWeight: '400' }}>Completed</div>
            <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
              {Number(collectionValue).toFixed(2)}
            </div>
          </div>
        </div>
      </div>

      {/* Second Card - Balance */}
      <div style={{
        position: 'absolute',
        top: '120px',
        left: '0',
        width: '100%',
        padding: '16px',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'start'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            backgroundColor: '#fad9cc',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '16px',
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#1a1a1a'
          }}>
            <img
              src="/pending .png"
              alt="Icon"
              style={{
                width: '80%',
                height: '80%',
                objectFit: 'cover'
              }}
            />
          </div>
          <div style={{ textAlign: 'left' }}>
            <div style={{ fontSize: '16px', fontWeight: '400' }}>Balance</div>
            <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
              {Number(recyclingValue).toFixed(2)}
            </div>
          </div>
        </div>
      </div>

      {/* Third Card - Collection */}
      <div style={{
        position: 'absolute',
        top: '250px',
        left: '0',
        width: '100%',
        padding: '16px',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'start'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            backgroundColor: '#fee9c0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '16px',
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#1a1a1a'
          }}>
            <img
              src="/collection .png"
              alt="Icon"
              style={{
                width: '80%',
                height: '80%',
                objectFit: 'cover'
              }}
            />
          </div>
          <div style={{ textAlign: 'left' }}>
            <div style={{ fontSize: '16px', fontWeight: '400' }}>Collection</div>
            <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
              {Number(collection).toFixed(2)}
            </div>
          </div>
        </div>
      </div>

      {/* Fourth Card - Recycling */}
      <div style={{
        position: 'absolute',
        top: '375px',
        left: '0',
        width: '100%',
        padding: '16px',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'start'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            backgroundColor: '#f5f3fe',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '16px',
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#1a1a1a'
          }}>
            <img
              src="/recycling .png"
              alt="Icon"
              style={{
                width: '80%',
                height: '80%',
                objectFit: 'cover'
              }}
            />
          </div>
          <div style={{ textAlign: 'left' }}>
            <div style={{ fontSize: '16px', fontWeight: '400' }}>Recycling</div>
            <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
              {Number(recycling).toFixed(2)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { CardsWidget17 }